import { render } from "./SubAgentAlHistory.vue?vue&type=template&id=7fae44e8&ts=true"
import script from "./SubAgentAlHistory.vue?vue&type=script&lang=ts"
export * from "./SubAgentAlHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__